import React from 'react';

export function CheckBox({ name, onChange, options, label, path, disable, requiredField, error }) {
  return (
    <>
      <label className="asterisk-req">
        {label}
        {requiredField && <span>*</span>}
      </label>
      {options?.map((opt, i) => {
        const manipulatedPath = `${path}.options[${i}].value`;
        return (
          <div className="checkbox-label" key={i}>
            <input
              type="checkbox"
              id={`${opt?.name}_${i}`}
              name={name}
              disabled={disable}
              onChange={(e) => onChange(e.target.checked, manipulatedPath)}
              checked={opt.value}
            />
            <label htmlFor={`${opt?.name}_${i}`} className="chklabel">
              <span>{opt?.name}</span>
            </label>
          </div>
        );
      })}
      {error?.status && <span className="error-message">{error.errorMsg}</span>}
    </>
  );
}
export default CheckBox;
